/* Caly: complementa a página e encaminha a compra ao formulário original do Dawn. */
(() => {
  if (!window.calySizeGuideReady) {
    window.calySizeGuideReady = true;
    document.addEventListener('click', (event) => {
      const link = event.target.closest('[data-caly-size-link]');
      if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      const dialog = link.closest('product-info')?.querySelector('.caly-size-dialog');
      if (!dialog || typeof dialog.showModal !== 'function') return;
      event.preventDefault();
      if (!dialog.open) dialog.showModal();
      // Clique no fundo externo fecha o diálogo; o conteúdo continua clicável.
      if (!dialog.dataset.calyReady) {
        dialog.dataset.calyReady = 'true';
        dialog.addEventListener('click', (e) => {
          if (e.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (e.clientX < rect.left || e.clientX > rect.right || e.clientY < rect.top || e.clientY > rect.bottom) dialog.close();
        });
      }
    });
  }

  if (customElements.get('caly-product-tools')) return;
  customElements.define('caly-product-tools', class extends HTMLElement {
    connectedCallback() {
      this.initFrame = requestAnimationFrame(() => this.init());
    }

    init() {
      this.root = this.closest('product-info');
      if (!this.root || this.closest('quick-add-modal') || this.root.dataset.updateUrl === 'false') return;
      this.info = this.root.querySelector('.product__info-container');
      this.button = this.querySelector('[data-caly-sticky-button]');
      this.price = this.querySelector('[data-caly-sticky-price]');
      if (!this.info || !this.button || !this.price) return;
      this.chosen = this.dataset.hasOptions === 'false' || new URL(location.href).searchParams.has('variant');
      this.onChange = (event) => {
        if (!event.target.closest('variant-selects')) return;
        this.chosen = true;
        this.queueSync();
      };
      this.onClick = () => {
        const picker = this.info.querySelector('variant-selects');
        const native = this.nativeButton();
        if (!native) return;
        if (!this.chosen && picker) {
          this.scrollTo(picker);
          const target = picker.querySelector('input:checked, select, input');
          target?.focus({ preventScroll: true });
          return;
        }
        if (native.disabled || native.getAttribute('aria-disabled') === 'true') return;
        native.click();
      };
      this.button.addEventListener('click', this.onClick);
      this.root.addEventListener('change', this.onChange);
      this.onViewport = () => this.queueSync();
      window.addEventListener('scroll', this.onViewport, { passive: true });
      window.addEventListener('resize', this.onViewport);
      this.observer = new MutationObserver(() => this.queueSync());
      this.observer.observe(this.info, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class', 'hidden'] });
      this.sync();
    }

    nativeButton() {
      return this.info?.querySelector('product-form .product-form__submit');
    }

    scrollTo(element) {
      const header = document.querySelector('.shopify-section-header-sticky, sticky-header');
      const offset = header ? Math.max(0, Math.min(header.getBoundingClientRect().bottom, 180)) : 0;
      window.scrollTo({ top: element.getBoundingClientRect().top + scrollY - offset - 20, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }

    queueSync() {
      if (this.syncFrame) return;
      this.syncFrame = requestAnimationFrame(() => { this.syncFrame = null; this.sync(); });
    }

    sync() {
      const native = this.nativeButton();
      if (!native) { this.hidden = true; return; }
      const priceContainer = this.info.querySelector('[id^="price-"]');
      const nativePrice = priceContainer?.querySelector('.price');
      this.price.hidden = !nativePrice || priceContainer.classList.contains('hidden');
      if (nativePrice) {
        const onSale = nativePrice.classList.contains('price--on-sale');
        const current = nativePrice.querySelector(onSale ? '.price__sale .price-item--sale' : '.price__regular .price-item--regular');
        const previous = onSale ? nativePrice.querySelector('.price__sale .price-item--regular') : null;
        const priceText = current?.textContent.trim() || '';
        const previousText = previous?.textContent.trim() || '';
        const signature = priceText + '|' + previousText;
        if (signature !== this.priceSignature) {
          this.price.replaceChildren();
          const strong = document.createElement('strong'); strong.textContent = priceText; this.price.append(strong);
          if (previousText) { const del = document.createElement('del'); del.textContent = previousText; this.price.append(del); }
          this.priceSignature = signature;
        }
      }
      const choosing = !this.chosen && !!this.info.querySelector('variant-selects');
      const busy = native.classList.contains('loading') || native.getAttribute('aria-disabled') === 'true';
      this.button.disabled = !choosing && (native.disabled || busy);
      const label = choosing ? 'Escolher opções' : busy ? 'Aguarde…' : native.disabled ? (native.querySelector('span')?.textContent.trim() || 'Indisponível') : 'Adicionar';
      if (this.button.textContent !== label) this.button.textContent = label;
      const rect = native.getBoundingClientRect();
      const inView = rect.bottom > 0 && rect.top < innerHeight - 90;
      const rootRect = this.root.getBoundingClientRect();
      this.hidden = inView || innerWidth >= 750 || rootRect.bottom < 0 || rootRect.top > innerHeight;
      this.root.classList.toggle('caly-has-sticky', innerWidth < 750);
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.initFrame);
      cancelAnimationFrame(this.syncFrame);
      this.observer?.disconnect();
      this.root?.removeEventListener('change', this.onChange);
      this.button?.removeEventListener('click', this.onClick);
      window.removeEventListener('scroll', this.onViewport);
      window.removeEventListener('resize', this.onViewport);
    }
  });
})();
